import { BdGraph, BdGraphStateMap } from '../../../lib/graph/graph.model';
import { EnginePositionModel } from '../models/engine-position.model';
import { ViewTreeNode } from '../models/view.tree-node';
import { HitModel } from '../models/hit.model';
import { ChapterInitModel } from '../models/engine-chapter-init-model';
import { ToolEnum } from '../models/tool.enum';

export class Load {
  static readonly type = '[Engine] Load';
  constructor() { }
}

export class LoadSuccess {
  static readonly type = '[Engine] Load Success';
  constructor(public result: string) { }
}

export class SetReady {
  static readonly type = '[Engine] Set Ready';
  constructor(public ready: boolean) { }
}

export class SetDisplay {
  static readonly type = '[Engine] Set Display of 3D Scene';
  constructor(public display: boolean) { }
}

export class SetVisible {
  static readonly type = '[Engine] Set Visibility of 3D Scene';
  constructor(public visible: boolean) { }
}


/**
 * Scene Handling
 */
export class SetGraph {
  static readonly type = '[Engine] Set Graph';
  constructor(public graph: BdGraph<ViewTreeNode>) { }
}

export class ClearGraph {
  static readonly type = '[Engine] Clear Graph';
  constructor() { }
}

export class SetEngineChapter {
  static readonly type = '[Engine] Set Engine Chapter';
  constructor(public chapterId: string) { }
}

export class SetEngineChapterInit {
  static readonly type = '[Eninge] Set Chapter Init';
  constructor(public chapterInit: ChapterInitModel) {}
}

export class ClickNode {
  static readonly type = '[Engine] Click Node';
  constructor(public node: ViewTreeNode, public event: HammerInput, public hit?: HitModel) {}
}

export class RightClickNode {
  static readonly type = '[Engine] Right Click Node';
  constructor(public node: ViewTreeNode, public event: Event, public hit?: HitModel) {}
}

export class FlyToNode {
  static readonly type = '[Engine] Fly To Node';
  constructor(public node: ViewTreeNode) {}
}

export class CenterCameraOnVisible {
  static readonly type = '[Engine] Center Camera on Visible Nodes';
  constructor() {}
}

export class SynchronizeVisibleNodes {
  static readonly type = '[Engine] Synchronize Visible Nodes On Tree';
  constructor(public leafVisibilityState: BdGraphStateMap) {}
}

export class SynchronizeRenderableNodes {
  static readonly type = '[Engine] Synchronize Renderable State of Nodes On Tree';
  constructor(public leafRenderableState: BdGraphStateMap) {}
}

export class SynchronizePickableNodes {
  static readonly type = '[Engine] Synchronize Pickable State of Nodes On Tree';
  constructor(public leafPickableState: BdGraphStateMap) {}
}

export class Hit {
  static readonly type = '[Engine] Hit';
  constructor(public hit: HitModel) { }
}

export class ToggleCameraBar {
  static readonly type = '[Engine] Toggle Camera Bar';
  constructor(public show: boolean) { }
}

export class ToggleLabels {
  static readonly type = '[Engine] Toggle Labels';
  constructor(public show: boolean) { }
}

export class SetActiveTool {
  static readonly type = '[Engine] Set active tool';
  constructor(public tool: ToolEnum) { }
}

export class PlayAnimation {
  static readonly type = '[Engine] Play animation';
  constructor(public play: boolean) { }
}


/**
 * Canvas element references
 */
export class SetEnginePosition {
  static readonly type = '[Engine] Set Engine Position';
  constructor(public position: EnginePositionModel) { }
}

export class ResetEnginePosition {
  static readonly type = '[Engine] Reset Engine Position';
  constructor() { }
}

export class ResetEngineInteractions {
  static readonly type = '[Engine] Reset Interactions';
  constructor() { }
}
